{
  "Accessibility menu": "ਪਹੁੰਚ ਮੇਨੂ",
  "Reset settings": "ਸੈਟਿੰਗਾਂ ਰੀਸੈਟ ਕਰੋ",
  "Close": "ਬੰਦ ਕਰੋ",
  "Content adjustments": "ਸਮੱਗਰੀ ਸੰਸ਼ੋਧਨ",
  "Navigation adjustments": "ਨੇਵੀਗੇਸ਼ਨ ਸੰਸ਼ੋਧਨ",
  "Align Left": "ਖੱਬੇ ਪਾਸੇ ਸੰਯੋਜਿਤ ਕਰੋ",
  "Adjust Font Size": "ਫੋਂਟ ਆਕਾਰ ਅਨੁਕੂਲਿਤ ਕਰੋ",
  "Highlight Title": "ਸਿਰਲੇਖ ਹਾਈਲਾਈਟ ਕਰੋ",
  "Highlight Links": "ਲਿੰਕ ਹਾਈਲਾਈਟ ਕਰੋ",
  "Readable Font": "ਪੜ੍ਹਨਯੋਗ ਫੋਂਟ",
  "Colour adjustments": "ਰੰਗ ਸੰਸ਼ੋਧਨ",
  "Dark Contrast": "ਗੂੜ੍ਹਾ ਵਿਰੋਧ",
  "Light Contrast": "ਹਲਕਾ ਵਿਰੋਧ",
  "High Contrast": "ਉੱਚਾ ਵਿਰੋਧ",
  "High Saturation": "ਉੱਚਾ ਸੰਤ੍ਰਿਪਤੀ",
  "Low Saturation": "ਘੱਟ ਸੰਤ੍ਰਿਪਤੀ",
  "Monochrome": "ਇਕ ਰੰਗੀ",
  "Tools": "ਉਪਕਰਨ",
  "Reading Guide": "ਪੜ੍ਹਨ ਗਾਈਡ",
  "Stop Animations": "ਐਨੀਮੇਸ਼ਨ ਰੋਕੋ",
  "Big Cursor": "ਵੱਡਾ ਕਰਸਰ",
  "Increase Font Size": "ਫੋਂਟ ਆਕਾਰ ਵਧਾਓ",
  "Decrease Font Size": "ਫੋਂਟ ਆਕਾਰ ਘਟਾਓ",
  "Letter Spacing": "ਅੱਖਰਾਂ ਦੀ ਦੂਰੀ",
  "Line Height": "ਲਾਈਨ ਦੀ ਉਚਾਈ",
  "Font Weight": "ਫੋਂਟ ਭਾਰ",
  "Dyslexia Font": "ਡਿਸਲੈਕਸੀਆ ਫੋਂਟ",
  "Language": "ਭਾਸ਼ਾ",
  "Accessibility widget": "ਪਹੁੰਚ ਮੇਨੂ ਖੋਲ੍ਹੋ",
  "Accessibility Profiles": "ਪਹੁੰਚ ਪ੍ਰੋਫਾਈਲ",
  "Cognitive Disability": "ਜਾਣਕਾਰੀ ਸੰਬੰਧੀ ਅਸਮਰੱਥਾ",
  "Seizure Safe": "ਦੌਰਾ ਸੁਰੱਖਿਅਤ",
  "Accessibility statement": "ਪਹੁੰਚ ਬਿਆਨ"
}
